import VBtn from '@/components/ui/v-btn/VBtn'
import VCard from '@/components/ui/v-card/index.js'
import VCheckbox from '@/components/ui/v-checkbox/VCheckbox'
import VChevron from '@/components/ui/v-chevron/VChevron'
import VCircle from '@/components/ui/v-circle/VCircle'
import VDateField from '@/components/ui/v-date-field/VDateField'
import VDatepicker from '@/components/ui/v-datepicker/VDatepicker'
import VDialog from '@/components/ui/v-dialog/VDialog'
import VDivider from '@/components/ui/v-divider/VDivider'
import VDropdown from '@/components/ui/v-dropdown/VDropdown'
import VIcon from '@/components/ui/v-icon/VIcon'
import VImageSkeleton from '@/components/ui/v-image-skeleton/VImageSkeleton'
import VInput from '@/components/ui/v-input/VInput'
import VInputR from '@/components/ui/v-inputr/VInputR'
import VList from '@/components/ui/v-list/index.js'
import VLoader from '@/components/ui/v-loader/VLoader'
import VMobileTabs from '@/components/ui/v-mobile-tabs/VMobileTabs'
import VMultiselect from '@/components/ui/v-multiselect/VMultiselect'
import VNavTabs from '@/components/ui/v-nav-tabs/VNavTabs'
import VPasswordField from '@/components/ui/v-password-field/VPasswordField'
import VPreloader from '@/components/ui/v-preloader/VPreloader'
import VRange from '@/components/ui/v-range/VRange'
import VScrollable from '@/components/ui/v-scrollable/VScrollable'
import VSelect from '@/components/ui/v-select/VSelect'
import VSwitch from '@/components/ui/v-switch/VSwitch'
import VTable from '@/components/ui/v-table/index.js'
import VTabs from '@/components/ui/v-tabs/index.js'
import VTextField from '@/components/ui/v-text-field/VTextField'
import VTimeField from '@/components/ui/v-time/VTimeField'
import VToggler from '@/components/ui/v-toggler/VToggler'

const registerComponents = (Vue, components) => {
  for (const key in components) {
    Vue.component(key, components[key])
  }
}

const UiComponents = {
  // eslint-disable-next-line no-unused-vars
  install (Vue, options) {
    Vue.component('VBtn', VBtn)
    Vue.component('VChevron', VChevron)
    Vue.component('VCircle', VCircle)
    Vue.component('VDialog', VDialog)
    Vue.component('VDivider', VDivider)
    Vue.component('VMultiselect', VMultiselect)
    Vue.component('VPreloader', VPreloader)
    Vue.component('VScrollable', VScrollable)
    Vue.component('VSelect', VSelect)
    Vue.component('VSwitch', VSwitch)
    Vue.component('VCheckbox', VCheckbox)
    Vue.component('VToggler', VToggler)
    Vue.component('VInput', VInput)
    Vue.component('VInputR', VInputR)
    Vue.component('VImageSkeleton', VImageSkeleton)
    Vue.component('VTextField', VTextField)
    Vue.component('VPasswordField', VPasswordField)
    Vue.component('VLoader', VLoader)
    Vue.component('VRange', VRange)
    Vue.component('VIcon', VIcon)
    Vue.component('VDropdown', VDropdown)
    Vue.component('VNavTabs', VNavTabs)
    Vue.component('VMobileTabs', VMobileTabs)
    Vue.component('VDateField', VDateField)
    Vue.component('VDatepicker', VDatepicker)
    Vue.component('VTimeField', VTimeField)

    registerComponents(Vue, VCard)
    registerComponents(Vue, VList)
    registerComponents(Vue, VTable)
    registerComponents(Vue, VTabs)
  }
}

export default UiComponents
